// This is a map of the minimum number of original moves, to the number of moves that will be reduced when super lollipop is enabled.
// For example. From levels 10 to 24, the player will have 2 moves reduced if they have a super lollipop active, from levels 25 to 30, the player will have 4 moves reduced, and so on.
// The version 3 of the move reduction values.
export const moveReductionValues: Record<number, number> = {
  10: 2, // 10 to 24 - No level starts with less than 10 moves
  25: 4, // 25 to 30
  31: 6, // 31 to 35
  36: 6, // 36 to 40
  41: 8, // 41 to 45
  46: 10, // 46+
};

// This is the losing streak that will trigger the offer of free moves if a player loses super lollipop and fails to win the level.
export const moveReductionContinueLoosingStreak = 5;

// This is the number of moves that will be offered for free if a player loses super lollipop and fails to win the level.
export const moveReductionContinueMoves = 10;
